import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { EnvironmentConfigService } from '../environment-config-service/environment-config.service';
import { EventService } from '../events/event.service';

/** Tracks whether app environment config is ready for login, registration, or scan flows. */
@Injectable({ providedIn: 'root' })
export class IntroEnvironmentGateService {
  constructor(private readonly environmentConfigService: EnvironmentConfigService) {}

  isReady(): boolean {
    return this.environmentConfigService.isEnvironmentReady();
  }

  /** Invokes callback immediately and again when environment finishes loading. */
  bind(onChange: (ready: boolean) => void): Subscription {
    onChange(this.isReady());
    return EventService.environmentLoaded.subscribe(() => onChange(true));
  }
}
